const {
  location: { href },
} = window

export const isDevelopment = process.env.NODE_ENV === "development"
export const isProduction = process.env.NODE_ENV === "production"
export const isNetlify = href.includes("netlify")
export const isLocalhost = href.includes("localHost")

export const isReactEnvironment = isDevelopment || (isProduction && isNetlify)
export const isMockDeploy = isLocalhost || isNetlify
